export default __webpack_public_path__ + "static/media/crane.c643aa9e.jpg";